import { render, staticRenderFns } from "./MenuFrame.vue?vue&type=template&id=7261b997&scoped=true"
import script from "./MenuFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuFrame.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MenuFrame.vue?vue&type=style&index=0&id=7261b997&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7261b997",
  null
  
)

export default component.exports